import { Card } from "@/shared/ui/Card";
import type { SupplierTabDef } from "./suppliers";

// Card compatta di anagrafica fornitore: nome, email ordini/contatto e
// 2-4 righe statiche su come funziona il flusso. Contenuti in
// ``suppliers.ts`` — qui solo presentazione.

export function SupplierAnagraficaCard({ def }: { def: SupplierTabDef }) {
  return (
    <Card className="mb-4 p-5">
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 mb-2">
        <h2 className="font-display text-[16px] font-bold text-ink">{def.nome}</h2>
        {def.email ? (
          <a
            href={`mailto:${def.email}`}
            className="tabular-nums text-[11.5px] text-ink-2 hover:text-accent"
          >
            {def.email}
          </a>
        ) : (
          <span className="tabular-nums text-[11.5px] text-ink-2">nessuna mail di riferimento</span>
        )}
      </div>
      <ul className="space-y-0.5">
        {def.flusso.map((riga) => (
          <li key={riga} className="text-[12.5px] text-ink-2 leading-relaxed">
            <span aria-hidden="true" className="mr-1.5 text-ink-2">
              ·
            </span>
            {riga}
          </li>
        ))}
      </ul>
    </Card>
  );
}
